module.exports = __webpack_public_path__ + "static/img/zjgn05.7df7b66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/zjgn05.jpg
// module id = 1428
// module chunks = 0